import { useState, useCallback, useEffect } from 'react';
import { Category } from '../types';
import { restaurantApi } from '../services/api';
import { useMerchant } from '../context/MerchantContext';

export const useMenuFetch = (restaurantId: string | undefined, initialActiveCategory: string | null) => {
  const { setMenuCategories } = useMerchant();
  const [categories, setCategories] = useState<Category[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const [activeCategory, setActiveCategory] = useState<string | null>(initialActiveCategory);

  const fetchMenu = useCallback(async (silent = false) => {
    if (!restaurantId) return;
    if (!silent) setIsLoading(true);
    setError(null);
    try {
      const data = await restaurantApi.getMenu(restaurantId);
      setCategories(data);
      setMenuCategories(data);
      if (data.length > 0 && !activeCategory) {
        setActiveCategory(data[0].id);
      }
      setIsLoading(false);
    } catch (err) {
      if (!silent) {
        setError(err instanceof Error ? err : new Error('An unknown error occurred'));
      }
      setIsLoading(false);
    }
  }, [restaurantId, activeCategory, setMenuCategories]);

  useEffect(() => {
    fetchMenu();
  }, [restaurantId]);

  useEffect(() => {
    if (!restaurantId) return;

    const interval = setInterval(() => {
      fetchMenu(true);
    }, 30000);

    return () => clearInterval(interval);
  }, [restaurantId, fetchMenu]);

  return {
    categories,
    isLoading,
    error,
    activeCategory,
    setActiveCategory,
    refetch: fetchMenu
  };
};
